import React, { useState, useEffect } from "react";
import * as api from "../../api/index";
import { jwtDecode } from "jwt-decode";
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { FiUser, FiPhone, FiMapPin, FiLock, FiEye, FiEyeOff, FiCheckCircle , FiEdit } from "react-icons/fi";

const lagosLGAs = [
  "All Lagos", "Agege", "Ajeromi-Ifelodun", "Alimosho", "Amuwo-Odofin", "Apapa",
  "Badagry", "Epe", "Eti-Osa", "Ibeju-Lekki", "Ifako-Ijaiye", "Ikeja", "Ikorodu",
  "Kosofe", "Lagos Island", "Lagos Mainland", "Mushin", "Ojo", "Oshodi-Isolo",
  "Shomolu", "Surulere",
];

const Editpage = () => {
  const [formData, setFormData] = useState({
    Name: "",
    Email: "",
    phone: "",
    lga: "",
    address: "",
    profileImage: null,
  });

  const [resetpassword, setResetPassword] = useState({
    NewPassword: "",
    ConfirmPassword: "",
  });

  const [loadingProfile, setLoadingProfile] = useState(false);
  const [loadingPassword, setLoadingPassword] = useState(false);
  const [showPassword, setShowPassword] = useState({
    NewPassword: false,
    ConfirmPassword: false,
  });
  const [profileMessage, setProfileMessage] = useState(null);
  const [passwordMessage, setPasswordMessage] = useState(null);
  const token = localStorage.getItem("token");
  const decoded = jwtDecode(token);
  const userId = decoded.id || decoded._id;

  const navigate = useNavigate();

  const togglePassword = (field) => {
    setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        setLoadingProfile(true);
        const res = await api.UserProfile(userId);

        setFormData({
          Name: res.data?.Name || "",
          Email: res.data?.Email || "",
          phone: res.data?.phone || "",
          lga: res.data?.lga || "",
          address: res.data?.address || "",
          profileImage: res.data?.profileImage || null,
        });
      } catch (error) {
        setProfileMessage({
          type: "error",
          text: error.response?.data?.message || "Failed to load profile.",
        });
      } finally {
        setLoadingProfile(false);
      }
    };

    fetchProfile();
  }, [userId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setResetPassword({ ...resetpassword, [name]: value });
  };

  const handleImageChange = (e) => {
    setFormData({ ...formData, profileImage: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingProfile(true);
    setProfileMessage(null);
    try {
      await api.editProfile({ ...formData, id: userId });
      setProfileMessage({
        type: "success",
        text: "Profile updated successfully ✅",
      });
      navigate(-1);
    } catch (error) {
      const message = error.response?.data?.message || error.message || "Something went wrong while updating your profile.";
      setProfileMessage({ type: "error", text: message });
    } finally {
      setLoadingProfile(false);
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setLoadingPassword(true);
    setPasswordMessage(null);
    try {
      await api.resetPasswordinProfile(resetpassword);
      setPasswordMessage({
        type: "success",
        text: "Password updated successfully ✅",
      });
      navigate(-1);
    } catch (error) {
      const message = error.response?.data?.message || error.message || "Something went wrong while updating your password.";
      setPasswordMessage({ type: "error", text: message });
    } finally {
      setLoadingPassword(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      {/* 🔝 Sticky Header */}
      <div className="sticky top-0 z-20 bg-white/80 backdrop-blur-md border-b px-4 py-4 flex justify-between items-center shadow-sm">
        <button
          onClick={() => navigate(-1)}
          className="p-2 hover:bg-gray-100 rounded-full transition flex items-center gap-1 text-gray-700"
        >
          <IoMdArrowBack size={24} />
          <span className="hidden sm:inline font-bold">Back</span>
        </button>
        <h1 className="text-lg font-black text-gray-900 tracking-tight">Edit Profile</h1>
        <button
          onClick={handleSubmit}
          disabled={loadingProfile}
          className={`px-5 py-2 rounded-xl font-bold text-sm transition-all active:scale-95 shadow-lg ${
            loadingProfile ? "bg-gray-300 text-gray-500 cursor-not-allowed" : "bg-orange-600 text-white shadow-orange-100 hover:bg-orange-700"
          }`}
        >
          {loadingProfile ? "Saving..." : "Save"}
        </button>
      </div>

      <div className="max-w-xl mx-auto p-4 sm:p-6">
        {/* Profile Card */}
        <div className="bg-white shadow-xl shadow-gray-200/50 rounded-[2.5rem] p-6 sm:p-10 border border-gray-100">
          {/* Message Bar */}
          {profileMessage && (
            <div className={`p-4 mb-6 rounded-2xl text-sm font-bold flex items-center gap-2 ${
              profileMessage.type === "success" ? "bg-green-50 text-green-700 border border-green-100" : "bg-red-50 text-red-700 border border-red-100"
            }`}>
              <FiCheckCircle /> {profileMessage.text}
            </div>
          )}

          {loadingProfile && <p className="text-center text-gray-400 font-bold animate-pulse mb-4">Syncing Profile...</p>}

          {!loadingProfile && (
            <div className="space-y-6">
              {/* Profile Image Circle */}
              <div className="flex flex-col items-center">
                <label htmlFor="profileImageUpload" className="relative group cursor-pointer">
                  <div className="w-32 h-32 rounded-[2.5rem] border-4 border-white shadow-xl overflow-hidden bg-gray-100 transition-transform group-hover:scale-105">
                    {formData.profileImage ? (
                      <img
                        src={typeof formData.profileImage === "string" ? formData.profileImage : URL.createObjectURL(formData.profileImage)}
                        alt="Profile"
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <img
                        src="https://res.cloudinary.com/dvuq6vmiy/image/upload/v1758705055/istockphoto-1288129985-612x612_hhrco1.jpg"
                        alt="Default"
                        className="w-full h-full object-cover"
                      />
                    )}
                    <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition flex items-center justify-center">
                      <FiUser className="text-white text-3xl" />
                    </div>
                  </div>
                  <div className="absolute -bottom-2 -right-2 bg-orange-600 text-white p-2 rounded-xl shadow-lg border-2 border-white">
                    <FiEdit size={14} />
                  </div>
                </label>
                <input id="profileImageUpload" type="file" accept="image/*" onChange={handleImageChange} className="hidden" />
                <p className="text-xs font-black text-gray-400 uppercase tracking-widest mt-4">Profile Photo</p>
              </div>

              {/* Input Fields */}
              <div className="space-y-4">
                <div className="bg-gray-50 p-4 rounded-3xl border border-gray-100 focus-within:border-orange-500 transition-all">
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 block">Full Name</label>
                  <div className="flex items-center gap-3">
                    <FiUser className="text-gray-400" />
                    <input
                      type="text"
                      name="Name"
                      value={formData.Name}
                      onChange={handleChange}
                      className="bg-transparent w-full text-gray-800 font-bold focus:outline-none"
                      placeholder="Enter your full name"
                      required
                    />
                  </div>
                </div>

                <div className="bg-gray-50 p-4 rounded-3xl border border-gray-100 focus-within:border-orange-500 transition-all">
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 block">Phone Number</label>
                  <div className="flex items-center gap-3">
                    <FiPhone className="text-gray-400" />
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="bg-transparent w-full text-gray-800 font-bold focus:outline-none"
                      placeholder="Enter your phone number"
                    />
                  </div>
                </div>

                <div className="bg-gray-50 p-4 rounded-3xl border border-gray-100 focus-within:border-orange-500 transition-all">
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 block">Local Government Area</label>
                  <div className="flex items-center gap-3">
                    <FiMapPin className="text-gray-400" />
                    <select
                      name="lga"
                      value={formData.lga}
                      onChange={handleChange}
                      className="bg-transparent w-full text-gray-800 font-bold focus:outline-none appearance-none"
                    >
                      <option value="">Select LGA</option>
                      {lagosLGAs.map((lga, index) => (
                        <option key={index} value={lga}>{lga}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="bg-gray-50 p-4 rounded-3xl border border-gray-100 focus-within:border-orange-500 transition-all">
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 block">Address</label>
                  <div className="flex items-center gap-3">
                    <FiMapPin className="text-gray-400" />
                    <input
                      type="text"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      className="bg-transparent w-full text-gray-800 font-bold focus:outline-none"
                      placeholder="Enter your residential address"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Password Reset Card */}
        <div className="mt-8 bg-white shadow-xl shadow-gray-200/50 rounded-[2.5rem] p-6 sm:p-10 border border-gray-100">
          <h2 className="text-xl font-black text-gray-900 mb-6 flex items-center gap-2">
            <FiLock className="text-red-500" /> Reset Password
          </h2>

          {passwordMessage && (
            <div className={`p-4 mb-6 rounded-2xl text-sm font-bold ${
              passwordMessage.type === "success" ? "bg-green-50 text-green-700" : "bg-red-50 text-red-700"
            }`}>
              {passwordMessage.text}
            </div>
          )}

          <div className="space-y-4">
            <div className="bg-gray-50 p-4 rounded-3xl border border-gray-100 relative focus-within:border-red-500 transition-all">
              <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 block">New Password</label>
              <input
                type={showPassword.NewPassword ? "text" : "password"}
                name="NewPassword"
                value={resetpassword.NewPassword}
                onChange={handlePasswordChange}
                className="bg-transparent w-full text-gray-800 font-bold focus:outline-none pr-10"
                placeholder="••••••••"
              />
              <button
                type="button"
                onClick={() => togglePassword("NewPassword")}
                className="absolute right-5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
              >
                {showPassword.NewPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
              </button>
            </div>

            <div className="bg-gray-50 p-4 rounded-3xl border border-gray-100 relative focus-within:border-red-500 transition-all">
              <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 block">Confirm Password</label>
              <input
                type={showPassword.ConfirmPassword ? "text" : "password"}
                name="ConfirmPassword"
                value={resetpassword.ConfirmPassword}
                onChange={handlePasswordChange}
                className="bg-transparent w-full text-gray-800 font-bold focus:outline-none pr-10"
                placeholder="••••••••"
              />
              <button
                type="button"
                onClick={() => togglePassword("ConfirmPassword")}
                className="absolute right-5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
              >
                {showPassword.ConfirmPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
              </button>
            </div>

            <button
              onClick={handlePasswordSubmit}
              disabled={loadingPassword}
              className={`w-full py-4 rounded-2xl font-black transition-all shadow-lg active:scale-95 ${
                loadingPassword ? "bg-gray-300 text-gray-500" : "bg-red-600 text-white shadow-red-100 hover:bg-red-700"
              }`}
            >
              {loadingPassword ? "Resetting..." : "Reset Password"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Editpage;